'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _didyoumean = require('didyoumean');

var _didyoumean2 = _interopRequireDefault(_didyoumean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configKeys = {
    appName: '',
    Container: '',
    historyMode: '',
    basename: '',
    layout: '',
    placeholder: '',
    component: '',
    router: '',
    extensions: '',
    plugins: '',
    initialState: '',
    autoStart: '',
    autoListen: ''
};

var routerKeys = {
    routes: '',
    notFound: '',
    cache: ''
};

function warn(info) {
    console.error('[BoneWeb createApp] ' + info + '\u6709\u6548\u7684\u914D\u7F6E\u9879\u5217\u8868\u8BF7\u67E5\u770B\uFF1Ahttps://bone.aliyun.com/bone-web/bonewebsdk.html?name=csonww');
}

function validate(key, keys) {
    if (!(key in keys)) {
        var match = (0, _didyoumean2.default)(key, (0, _keys2.default)(keys));

        if (match) {
            warn('\u914D\u7F6E\u9879 ' + key + ' \u4E66\u5199\u9519\u8BEF\uFF0C\u4F60\u662F\u8981\u914D\u7F6E ' + match + ' \u5417\uFF1F');
        } else {
            warn('\u914D\u7F6E\u9879 ' + key + ' \u65E0\u6548\uFF0C');
        }
    }
}

exports.default = function () {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _keys2.default)(config).forEach(function (key) {
        validate(key, configKeys);
    });

    if (config.router) {
        (0, _keys2.default)(config.router).forEach(function (key) {
            validate(key, routerKeys);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web@0.2.0-alpha.7@@bone/web/lib/validateConfig.js
// module id = 2552
// module chunks = 4